import ExtendableError from './../error'
import {ResponseDTO} from './ResponseDTO'
import {inArray} from './../utils'

export const API_ERROR_TYPE_INTERNAL = 'internal',
      API_ERROR_TYPE_NORMAL = 'normal',
      API_ERROR_TYPE_HIDDEN = 'hidden',
      API_ERROR_TYPE_REDIRECT = 'redirect'

/**
 * This custom Error class will be used on all error rejects and throws.
 * It holds a custom message and the original response data.
 *
 * @param message String|Number
 * @param response ResponseDTO instance
 * @param type String It can be "internal" or "normal"
 */
export class APIServiceError extends ExtendableError
{
    constructor ( message, response, type = API_ERROR_TYPE_INTERNAL, parentException = null ) {

        if( message === '' || message === undefined ) {
            message = '[APIServiceError] Undefined error message.'
        }

        super(message)

        // type
        let types = [API_ERROR_TYPE_INTERNAL, API_ERROR_TYPE_NORMAL, API_ERROR_TYPE_HIDDEN, API_ERROR_TYPE_REDIRECT]
        if( ! inArray(type, types) ) {
            response = new ResponseDTO('[APIServiceError::constructor()] The "type" parameter can be one of the following values: ('+ types.join(', ') +').')
        }
        this.type = type

        // response
        if( response === undefined )
        {
            response = new ResponseDTO( message )
        }
        else if ( ! (response instanceof ResponseDTO) )
        {
            response = new ResponseDTO('[APIServiceError::constructor()] The "response" parameter need to be instance of ResponseDTO.')
        }

        this.response = response

        // parent exception
        this.parent = parentException
    }

    getResponse() {
        return this.response
    }

    getType() {
        return this.type
    }

    /**
     * Get parent exception if any
     * @return {Error} Original error instance
     */
    getParent() {
        return this.parent
    }
}
